var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0 fill-height",attrs:{"fluid":""}},[_c('Map',{on:{"select-site":_vm.selectSite}}),_c('SiteDrawer',{ref:"siteDrawer"}),_c('Filters'),_c('Logout'),_c('map-legend')],1)}
var staticRenderFns = []

export { render, staticRenderFns }